document.addEventListener("DOMContentLoaded", function () {
  const form = document.querySelector('form[action^="/cart/add"]');
  if (!form) return;

  const backSelect = document.querySelector('select[name="properties[Back Print Option]"]');
  const armSelect = document.querySelector('select[name="properties[Arm Print Option]"]');
  const backTextWrapper = document.getElementById("backPrintText");
  const armTextWrapper = document.getElementById("armPrintText");

  // Show/hide textarea logic
  function toggleTextarea(selectEl, wrapperEl) {
    if (selectEl?.value === "Yes") {
      wrapperEl?.classList.remove("hidden");
    } else {
      wrapperEl?.classList.add("hidden");
    }
  }

  toggleTextarea(backSelect, backTextWrapper);
  toggleTextarea(armSelect, armTextWrapper);

  backSelect?.addEventListener("change", () => toggleTextarea(backSelect, backTextWrapper));
  armSelect?.addEventListener("change", () => toggleTextarea(armSelect, armTextWrapper));

  // Add-to-cart logic
  form.addEventListener("submit", function (e) {
    e.preventDefault();

    const formData = new FormData(form);
    const addOnItems = [];

    // ✅ Add logs for debugging
    console.log("🟡 Back Print Value:", backSelect?.value);
    console.log("🟡 Arm Print Value:", armSelect?.value);

    if (backSelect && backSelect.value === "Yes") {
      addOnItems.push({
        id: "48991616041251",
        quantity: 1,
        properties: { _addon: "Back Print" }
      });
    }

    if (armSelect && armSelect.value === "Yes") {
      addOnItems.push({
        id: "53990390235427",
        quantity: 1,
        properties: { _addon: "Arm Print" }
      });
    }

    // ✅ Log what we're trying to send
    console.log("🟢 Add-on items to send:", addOnItems);

    // Submit base product
    fetch('/cart/add.js', {
      method: 'POST',
      body: formData
    })
      .then(() => {
        if (addOnItems.length === 0) return;
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: addOnItems })
        });
      })
     .then(() => {
  window.location.href = '/cart';
})
.catch((err) => {
  console.error("❌ Add-to-cart error:", err);
  alert('There was an error adding your items to the cart.');
});
  });
});